import { ca } from '@cian/analytics';

export function trackOpenInformer() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'card',
    action: 'click_sopr',
    label: 'heat_index',
  });
}
